"use client";

import { BookMenuContext } from "@/context/bookMenuContext";
import { LanguageContext } from "@/context/languageContext";
import styles from "@/styles/modules/components/restaurants/openingTimes.module.scss";
import { OpeningTimesComponent } from "@/types/modules";
import { translate } from "@/utils/translate";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useContext, useEffect } from "react";

interface OpeningTimesProps {
  openingTimes: OpeningTimesComponent;
}

export default function OpeningTimes({ openingTimes }: OpeningTimesProps) {
  const pathname = usePathname();

  const { language } = useContext(LanguageContext);
  const { openBookMenu, setEatAndDrinskRestaurantValue, setCurrentBookMenu } =
    useContext(BookMenuContext);

  const handleBookTable = () => {
    setCurrentBookMenu(3);
    setEatAndDrinskRestaurantValue(pathname.split("/")[2]);
    openBookMenu();
  };

  useEffect(() => {
    setCurrentBookMenu(3);
    setEatAndDrinskRestaurantValue(pathname.split("/")[2]);
  }, [pathname, setEatAndDrinskRestaurantValue, setCurrentBookMenu]);

  return (
    <section className={styles.openingTimes}>
      <div className={styles.openingTimesContainer}>
        <div className={styles.image} data-aos="fadeIn">
          {openingTimes.image && (
            <Image
              alt={openingTimes.image.node.altText || "Imperial Riding School"}
              src={openingTimes.image.node.link}
              width={openingTimes.image.node.mediaDetails.width}
              height={openingTimes.image.node.mediaDetails.height}
            />
          )}
        </div>
        <div className={styles.text} data-aos="fadeIn" data-aos-delay="200">
          <div className={styles.titles}>
            <h3>{translate["openingTimes"][language]}</h3>
            {/* <h3>{translate["menus"][language]}</h3> */}
          </div>
          {openingTimes.openingTimes &&
            openingTimes.openingTimes.map((item, i) => (
              <div key={i} className={styles.openingTime}>
                <p>{item.text}</p>
                <p>
                  {item.menu && (
                    <Link href={item.menu.url} target={item.menu.target}>
                      {item.menu.title}
                    </Link>
                  )
                  }
                </p>
              </div>
            ))}
          <div className={styles.button} data-aos="fadeIn" data-aos-delay="200">
            <button onClick={handleBookTable}>
              {translate["bookATable"][language]}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
